import React from 'react'
import { SurfacePalette, type } from '../../tokens'
import { SectionCard } from './SectionCard'

interface Props {
  palette: SurfacePalette
  packetID: number
}

export const CreativePlaceholderSection = ({ palette, packetID }: Props) => (
  <SectionCard
    palette={palette}
    sectionKey="creative"
    title="Creative"
    muted
    commentAnchor={{ type: 'section', id: `${packetID}:creative`, label: 'Creative' }}
  >
    <p style={{ margin: 0, fontSize: type.size.body, color: palette.textMuted }}>
      Placeholder for v0. v0.9.1 lands a minimum creative comment embed; the full Ad Preview
      integration and dynamic-creative summary follow in v1.3 and v1.4.
    </p>
  </SectionCard>
)
